import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!\n  Copyright (c) HashiCorp, Inc.\n}}\n\n<li class=\'cut-list-item--generic\'>\n  {{yield}}\n</li>")